import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "articles__tabs"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "articles__grid"
}
const _hoisted_5 = ["href", "aria-label"]
const _hoisted_6 = { class: "articles-card__content" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 2,
  class: "articles__empty"
}
const _hoisted_9 = {
  key: 3,
  class: "articles__loading"
}

import { computed, onMounted, ref, watch } from 'vue';
import api from '@/api';
import utils from '@/utils';
import type { ArticlesProps } from '@/types/components/Articles';


export default /*@__PURE__*/_defineComponent({
  __name: 'Articles',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref('all');
const currentPage = ref<number>(1);
const isLoading = ref(false);
const articles = ref<any[]>([]);
const totalCount = ref(0);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'articles'));
const rootStyle = computed(() => utils.overall.baseComStyle(props.fields));

const pageSize = computed(() => {
  const value = props.fields?.pageSize?.value;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : 6;
});

const normalizeKey = (value?: string) => {
  return value?.toLowerCase()?.replace(/\s+/g, '') || '';
};

const tabs = computed(() => {
  const configuredTabs = props.fields?.tabs || [];
  const items = configuredTabs.map((tab) => ({
    label: tab.fields?.tabName?.value || '',
    key: normalizeKey(tab.fields?.tabKey?.value || tab.fields?.tabName?.value),
  }));

  return items;
});

const totalPages = computed(() => {
  return Math.max(1, Math.ceil(totalCount.value / pageSize.value));
});

const paginatedArticles = computed(() => articles.value);

const loadArticles = async () => {
  isLoading.value = true;
  try {
    const [res, ex] = await api.articles.getArticles({
      page: currentPage.value,
      size: pageSize.value,
      tag: activeTab.value === 'all' ? '' : activeTab.value,
    });
    const data = res || ex;
    articles.value = data?.list || [];
    totalCount.value = data?.total || articles.value.length;
  } catch (error) {
    articles.value = [];
    totalCount.value = 0;
  } finally {
    isLoading.value = false;
  }
};

const changeTab = (tab: string) => {
  const nextTab = tab || 'all';
  if (activeTab.value === nextTab) return;

  activeTab.value = nextTab;
  if (currentPage.value === 1) {
    loadArticles();
    return;
  }
  currentPage.value = 1;
};

const getItemHref = (item: any) => {
  return item?.fields.url?.value?.url || '#';
};

const getTitleText = (item: any) => {
  return item?.fields?.articleTitle?.value?.replace(/<[^>]+>/g, '') || 'Article detail';
};

watch(totalPages, (value) => {
  if (currentPage.value > value) currentPage.value = value;
});

watch(currentPage, loadArticles);

onMounted(loadArticles);

return (_ctx: any,_cache: any) => {
  const _component_AdaptiveImage = _resolveComponent("AdaptiveImage")!
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(rootClass.value),
    style: _normalizeStyle(rootStyle.value),
    id: __props.rendering?.dataSource
  }, [
    _createVNode(_component_ContentGrid, {
      "desktop-default-grid": [2, 20],
      "mobile-default-grid": [1, 14]
    }, {
      default: _withCtx(() => [
        (tabs.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: tab.key,
                  class: _normalizeClass(["articles__tab", { 'is-active': activeTab.value === tab.key }]),
                  type: "button",
                  onClick: ($event: any) => (changeTab(tab.key))
                }, _toDisplayString(tab.label), 11, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (paginatedArticles.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedArticles.value, (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id || item.url,
                  class: "articles-card"
                }, [
                  _createElementVNode("a", {
                    class: "articles-card__media-link",
                    href: getItemHref(item),
                    "aria-label": getTitleText(item),
                    target: "_block"
                  }, [
                    _createVNode(_component_AdaptiveImage, {
                      class: "articles-card__image",
                      field: { fields: item?.fields?.articleImage?.value },
                      "is-background": false
                    }, null, 8, ["field"])
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_JssRichText, {
                      class: "articles-card__title",
                      field: item?.fields?.articleTitle,
                      tag: "h3"
                    }, null, 8, ["field"]),
                    _createVNode(_component_JssRichText, {
                      class: "articles-card__summary",
                      field: item?.fields?.articleSubtitle
                    }, null, 8, ["field"]),
                    _createElementVNode("a", {
                      class: "articles-card__link",
                      href: getItemHref(item),
                      target: "_block"
                    }, _toDisplayString(item?.fields?.articleButton?.value?.text?.value ||
                __props.fields?.learnMoreText?.value ||
                'Learn More'), 9, _hoisted_7)
                  ])
                ]))
              }), 128))
            ]))
          : (!isLoading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.fields?.emptyText?.value || 'No articles found.'), 1))
            : _createCommentVNode("", true),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Loading..."))
          : _createCommentVNode("", true),
        (totalPages.value > 1)
          ? (_openBlock(), _createBlock(_component_Pagination, {
              key: 4,
              currentPage: currentPage.value,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
              totalPages: totalPages.value
            }, null, 8, ["currentPage", "totalPages"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 14, _hoisted_1))
}
}

})